export default function shortenString(str) {
	return (str.length > 70 ? str.slice(0,70) + "..." : str).replaceAll("\\","");
}